import { get,get1,post2 } from './request.js'

//手机账号登录发送验证码
export const sendCode = (params,config) => get1('/passport/main.zlongame', params,config)
//手机账号登录
export const phoneLogin = params => get1('/passport/method_login.zlongame', params)
//获取平台角色列表
export const getRoleList = params => get('/activity/branch/user/redirect/roles.do', params)
//检查角色是否符合条件
export const getCheck = params => get('/activity/branch/user/redirect/check.do', params)
//获取转移记录
export const getRecords = params => get('/activity/branch/user/redirect/records.do', params)
//支付调取
export const pay = params => post2(`/pay-service/webpay/do?t=${new Date().getTime()}`, params)

